/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_DescriptionInputs */

const en_wb_sales_description = /** @type {(inputs: Wb_Sales_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the tone and the proposed next step before this goes to a customer.`)
};

const lv_wb_sales_description = /** @type {(inputs: Wb_Sales_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudiet toni un piedāvāto nākamo soli, pirms tas nonāk pie klienta.`)
};

/**
* | output |
* | --- |
* | "Check the tone and the proposed next step before this goes to a customer." |
*
* @param {Wb_Sales_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_description = /** @type {((inputs?: Wb_Sales_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_description(inputs)
	return en_wb_sales_description(inputs)
});